// Polyfills for older browsers (must be the first imports)
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress known harmless console errors in development
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    const errorMessage = args[0]?.toString() || '';
    
    // Suppress Stripe errors when blocked by ad blockers
    if (errorMessage.includes('r.stripe.com') || 
        errorMessage.includes('ERR_BLOCKED_BY_CLIENT') ||
        errorMessage.includes('FetchError: Error fetching https://r.stripe.com')) {
      return; // Silently ignore these errors
    }
    
    // Suppress WebSocket connection errors (webpack-dev-server HMR)
    if (errorMessage.includes('WebSocket connection') || 
        errorMessage.includes('ws://localhost')) {
      return; // Silently ignore these errors
    }
    
    // Call original console.error for all other errors
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
